export default __webpack_public_path__ + "navigation-camera-bearing-smoothing-disabled-1200-7969d2a8c35b533c78668c13253a6b6b.webp";